module.exports = __webpack_public_path__ + "static/img/7.ca1d43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/7.png
// module id = GiCK
// module chunks = 1